import { KYMW4300Component } from './kymw4300.component';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';

/**
 * 商品ＤＮＡ情報一覧画面の値を管理するクラス
 *
 * @export KYMW4300Model
 * @class KYMW4300Model
 */
export class KYMW4300Model {

  kymw4300Component: KYMW4300Component;

  // API戻り値のファイル名保存用
  public fileName: string = <string>'';

  // ラジオボタン
  public rbtg_targetGoods: string = <string>'1';
  public cmb_AdmitStatusGroup: string = <string>'';

  // 取引先
  public ordrClientCode: string = <string>'';
  public payeeClientCode: string = <string>'';

  // テキスト
  public orderCodeFrom: string = <string>'';
  public orderCodeTo: string = <string>'';
  public catalogId_From: string = <string>'';
  public catalogId_To: string = <string>'';
  public pCode: string = <string>'';
  public itemCode: string = <string>'';
  public eBaseSpecCode: string = <string>'';
  public jANCode: string = <string>'';
  public makerName: string = <string>'';
  public pCodeList: string = <string>'';

  /**
   * ファイル名を更新する
   *
   * @param serverData サーバ取得データ
   */
  public updateFileName(serverData: any): void {
    this.fileName = serverData.FileName;
  }
}
